import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Technology from "../pages/technology/page";
import Products from "../pages/products/page";
import Sustainability from "../pages/sustainability/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/technology",
    element: <Technology />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/sustainability",
    element: <Sustainability />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;